import AccountOpeningSteps from './container/AccountOpeningSteps';

export default AccountOpeningSteps;



// WEBPACK FOOTER //
// ./src/views/AccountOpeningSteps/index.js